import { Divider } from "antd";
import color from "../../../theme/color";

/**
 * 12px gutter divider
 * @returns
 */
export const BoldDivider = () => (
  <Divider style={{ borderTopWidth: 12, margin: 0, color: color.gray10 }} />
);
